import { BaSeBreakpointContext, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import Button from '../components/button';
import { LayoutCandidate } from '../components/layout-candidate';
import {
  BackgroundCandidate,
  ImageEmpretecText,
  Wrapper,
  WrapperButtons,
} from './candidate-home-styled';

export const CandidateHome = () => {
  const { isAuthenticated, login } = Sebrae.useAuth();
  const { navigateTo } = Sebrae.useSebraeRouter();
  const breakpointController = React.useContext(BaSeBreakpointContext);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigateTo('/candidato');
    }
  }, [isAuthenticated, login, navigateTo]);

  return (
    <LayoutCandidate>
      <BackgroundCandidate>
        <Wrapper>
          <ImageEmpretecText inDesktop={breakpointController.inDesktop} />
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
            O Empretec é o principal programa de formação de empreendedores do
            mundo, um seminário intensivo criado pela Organização das Nações
            Unidas (ONU), promovido em 40 países e exclusivo do Sebrae no
            Brasil.
          </BaSeParagraph>
          <div>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae75}
            >
              Empreender é acreditar no seu potencial!
            </BaSeParagraph>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae75}
            >
              Ser um Empreteco é dar o primeiro passo para uma jornada de
              sucesso e encontrar o empreendedor que está dentro de você.
            </BaSeParagraph>
          </div>
          <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
            Caso já tenha entrado em contato com o Sebrae do seu Estado e tenha
            uma entrevista criada, favor realize o login para iniciar o
            preenchimento de sua entrevista/questionário de seleção.
          </BaSeParagraph>
          <WrapperButtons>
            <Button
              withBorder={true}
              borderColor={'#15b69f'}
              color={'#06332c'}
              value={'REALIZAR LOGIN'}
              valueSmall={'LOGIN'}
              calback={() => login()}
            />
            <Button
              withBorder={true}
              borderColor={'#06332c'}
              color={BaSeTheme.colors.defaultColors.transparent}
              value={'NÃO TENHO ENTREVISTA'}
              valueSmall={'NÃO TENHO ENTREVISTA'}
              calback={() =>
                (window.location.href =
                  'https://sebrae.com.br/sites/PortalSebrae/empretec')
              }
            />
          </WrapperButtons>
        </Wrapper>
      </BackgroundCandidate>
    </LayoutCandidate>
  );
};
